import {Component, Input, OnInit} from '@angular/core';
import {QuestionModel} from '../../../../../models/questions/question.model';
import {SizeComparisonWordsModel} from '../../../../../models/questions/subModels/sizeComparisonWords.model';
import {Enums} from '../../../../../models/extensions/enums';

@Component({
  selector: 'app-evo-size-comparison-words',
  templateUrl: './evo-size-comparison-words.component.html',
  styleUrls: ['./evo-size-comparison-words.component.css']
})
export class EvoSizeComparisonWordsComponent implements OnInit {

  Enums = Enums;
  QuestionModel = QuestionModel;
  @Input() question: QuestionModel = new SizeComparisonWordsModel();


  constructor() { }

  ngOnInit() {
  }

  castedQuestion(): SizeComparisonWordsModel {

    return <SizeComparisonWordsModel>this.question;
  }

  showQuestion(): boolean {

    if (this.question) {
      if (this.question.subCategory === Enums.QuestionSubcategories.sizeComparisonWords) {
        return true;
      }
    }

    return false;
  }

}
